(function () {
  'use strict';

  const source = document.currentScript;
  if (!source) return;
  const selector = '.responsive, .custom_coll_sec .outer_loop, .custom_testimonial .outer_loop_new';
  const focusable = 'a[href], button, input, select, textarea, summary, [tabindex]';
  const states = new WeakMap();
  const originalTabIndex = new WeakMap();
  let resources;

  function loadResources() {
    if (resources) return resources;
    const nodes = [];
    const timers = [];
    function load(node) {
      nodes.push(node);
      const pending = new Promise((resolve, reject) => {
        const timer = window.setTimeout(() => reject(new Error('Carousel resource timeout')), 8000);
        timers.push(timer);
        node.onload = () => { window.clearTimeout(timer); resolve(); };
        node.onerror = () => { window.clearTimeout(timer); reject(new Error('Carousel resource unavailable')); };
      });
      source.parentNode.insertBefore(node, source);
      return pending;
    }
    function loadScript(url) {
      const script = document.createElement('script');
      script.src = url;
      script.async = true;
      return load(script);
    }
    const style = document.createElement('link');
    style.rel = 'stylesheet';
    style.href = source.dataset.slickStyle;
    const styles = load(style);
    const scripts = (window.jQuery ? Promise.resolve() : loadScript(source.dataset.jqueryScript)).then(() => {
      if (!window.jQuery || !window.jQuery.fn) throw new Error('Carousel dependency unavailable');
      if (!window.jQuery.fn.slick) return loadScript(source.dataset.slickScript);
    }).then(() => {
      if (!window.jQuery.fn.slick) throw new Error('Carousel dependency unavailable');
    });
    resources = Promise.all([styles, scripts]).catch((error) => {
      timers.forEach((timer) => window.clearTimeout(timer));
      nodes.forEach((node) => node.remove());
      resources = undefined;
      throw error;
    });
    return resources;
  }

  function optionsFor(element) {
    const common = { dots: true, speed: 300, rows: 0, autoplay: false, accessibility: true };
    if (element.matches('.responsive')) {
      return Object.assign(common, {
        infinite: false, slidesToShow: 6, slidesToScroll: 6,
        responsive: [
          { breakpoint: 1280, settings: { slidesToShow: 5, slidesToScroll: 5 } },
          { breakpoint: 1080, settings: { slidesToShow: 3, slidesToScroll: 3 } },
          { breakpoint: 680, settings: { slidesToShow: 2, slidesToScroll: 2 } },
          { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } },
        ],
      });
    }
    if (element.matches('.custom_coll_sec .outer_loop')) {
      return Object.assign(common, {
        infinite: false, slidesToShow: 4, slidesToScroll: 4,
        responsive: [
          { breakpoint: 1080, settings: { slidesToShow: 3, slidesToScroll: 3 } },
          { breakpoint: 680, settings: { slidesToShow: 2, slidesToScroll: 2 } },
          { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } },
        ],
      });
    }
    return Object.assign(common, {
      infinite: false, arrows: false, slidesToShow: 3, slidesToScroll: 3,
      responsive: [
        { breakpoint: 1180, settings: { centerMode: true, centerPadding: '60px', slidesToShow: 2, slidesToScroll: 2 } },
        { breakpoint: 880, settings: { centerMode: false, slidesToShow: 2, slidesToScroll: 2 } },
        { breakpoint: 680, settings: { centerMode: false, slidesToShow: 1, slidesToScroll: 1 } },
      ],
    });
  }

  function updateAccessibility(element) {
    if (!element.isConnected || !element.classList.contains('slick-initialized')) return;
    element.querySelectorAll('.slick-slide').forEach((slide) => {
      const active = slide.classList.contains('slick-active') && !slide.classList.contains('slick-cloned');
      slide.setAttribute('aria-hidden', String(!active));
      if (!active) slide.setAttribute('tabindex', '-1');
      slide.querySelectorAll(focusable).forEach((control) => {
        const original = originalTabIndex.get(control);
        if (!active) control.setAttribute('tabindex', '-1');
        else if (original == null) control.removeAttribute('tabindex');
        else control.setAttribute('tabindex', original);
      });
    });
    const previous = element.querySelector('.slick-prev');
    const next = element.querySelector('.slick-next');
    if (previous) previous.setAttribute('aria-label', source.dataset.previousLabel);
    if (next) next.setAttribute('aria-label', source.dataset.nextLabel);
    const dots = element.querySelectorAll('.slick-dots button');
    dots.forEach((dot, index) => dot.setAttribute('aria-label', `${index + 1} ${source.dataset.positionLabel} ${dots.length}`));
    const focusedSlide = document.activeElement && document.activeElement.closest('.slick-slide');
    if (focusedSlide && element.contains(focusedSlide) && focusedSlide.getAttribute('aria-hidden') === 'true') {
      const target = element.querySelector('.slick-active:not(.slick-cloned) a[href], .slick-active:not(.slick-cloned) button, .slick-dots .slick-active button');
      if (target) target.focus({ preventScroll: true });
    }
  }

  function initialize(element) {
    const state = states.get(element);
    if (!state || state.loading || state.ready || !element.isConnected) return;
    state.loading = true;
    if (observer) observer.unobserve(element);
    loadResources().then(() => {
      if (!element.isConnected || states.get(element) !== state || !window.jQuery.fn.slick) return;
      element.querySelectorAll(focusable).forEach((control) => originalTabIndex.set(control, control.getAttribute('tabindex')));
      const slider = window.jQuery(element);
      slider.on('init.stCarousel reInit.stCarousel afterChange.stCarousel breakpoint.stCarousel', () => {
        Promise.resolve().then(() => updateAccessibility(element));
      });
      slider.slick(optionsFor(element));
      state.ready = true;
    }).catch(() => {
      states.delete(element);
    });
  }

  const observer = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach((entry) => { if (entry.isIntersecting) initialize(entry.target); });
  }, { rootMargin: '500px 0px' }) : null;

  function findCarousels(root) {
    const elements = Array.from(root.querySelectorAll(selector));
    if (root.matches && root.matches(selector)) elements.unshift(root);
    return elements;
  }

  function discover(root, immediate) {
    findCarousels(root).forEach((element) => {
      if (states.has(element) || element.classList.contains('slick-initialized')) return;
      states.set(element, { loading: false, ready: false });
      if (immediate || !observer) initialize(element);
      else observer.observe(element);
    });
  }

  function unload(root) {
    findCarousels(root).forEach((element) => {
      if (observer) observer.unobserve(element);
      states.delete(element);
      if (window.jQuery && window.jQuery.fn.slick && element.classList.contains('slick-initialized')) {
        window.jQuery(element).off('.stCarousel').slick('unslick');
        element.querySelectorAll(focusable).forEach((control) => {
          if (!originalTabIndex.has(control)) return;
          const original = originalTabIndex.get(control);
          if (original == null) control.removeAttribute('tabindex');
          else control.setAttribute('tabindex', original);
        });
      }
    });
  }

  function ready() { discover(document, Boolean(window.Shopify && window.Shopify.designMode)); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, { once: true });
  else ready();
  document.addEventListener('shopify:section:load', (event) => discover(event.target, true));
  document.addEventListener('shopify:section:unload', (event) => unload(event.target));
})();
